module.exports = __webpack_public_path__ + "static/media/loading-screen.63ff6eb7.gif";